<template>
  <div>
    <div :data-phone="edition" class="col-md-12 px-0 py-0">
      <v-form ref="formcity">
        <v-autocomplete
          v-model="selectedState"
          :clearable="selectedState !== ''"
          :items="states"
          :no-data-text="$t('LISTS.NoData')"
          :required="force"
          clear-icon="mdi-close-circle-outline"
          dense
          item-text="name"
          item-value="id"
          label="استان"
          outlined
          placeholder="نام استان مورد نظر را جستجو کنید."
          :rules="[
            (v) => (!!v && v !== '') || 'فیلد استان را نباید خالی بگذارید!',
          ]"
          :error-messages="errorState"
          @change="checkCity($event)"
          @input="getState($event)"
        >
          <template v-slot:prepend-inner>
            <span class="svg-icon svg-icon-primary svg-icon-2x">
              <svg
                height="24px"
                version="1.1"
                viewBox="0 0 24 24"
                width="24px"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g
                  fill="none"
                  fill-rule="evenodd"
                  stroke="none"
                  stroke-width="1"
                >
                  <rect height="24" width="24" x="0" y="0" />
                  <path
                    d="M9.82829464,16.6565893 C7.02541569,15.7427556 5,13.1079084 5,10 C5,6.13400675 8.13400675,3 12,3 C15.8659932,3 19,6.13400675 19,10 C19,13.1079084 16.9745843,15.7427556 14.1717054,16.6565893 L12,21 L9.82829464,16.6565893 Z M12,12 C13.1045695,12 14,11.1045695 14,10 C14,8.8954305 13.1045695,8 12,8 C10.8954305,8 10,8.8954305 10,10 C10,11.1045695 10.8954305,12 12,12 Z"
                    fill="#000000"
                  />
                </g>
              </svg>
            </span>
          </template>
        </v-autocomplete>

        <v-autocomplete
          v-if="cityInfo.state.length > 0"
          v-model="selectedCity"
          clearable
          :items="city"
          :no-data-text="$t('LISTS.NoData')"
          :required="force"
          clear-icon="mdi-close-circle-outline"
          dense
          item-text="name"
          item-value="id"
          label="شهر"
          name="city"
          outlined
          :rules="[
            (v) => (!!v && v !== '') || 'فیلد شهر را نباید خالی بگذارید!',
          ]"
          placeholder="نام شهر مورد نظر را جستجو کنید."
          :error-messages="errorCity"
          @change="checkNeighbor($event)"
          @input="getCity($event)"
        >
          <template v-slot:prepend-inner>
            <span class="svg-icon svg-icon-primary svg-icon-2x">
              <svg
                height="24px"
                version="1.1"
                viewBox="0 0 24 24"
                width="24px"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g
                  fill="none"
                  fill-rule="evenodd"
                  stroke="none"
                  stroke-width="1"
                >
                  <rect height="24" width="24" x="0" y="0" />
                  <path
                    d="M9.82829464,16.6565893 C7.02541569,15.7427556 5,13.1079084 5,10 C5,6.13400675 8.13400675,3 12,3 C15.8659932,3 19,6.13400675 19,10 C19,13.1079084 16.9745843,15.7427556 14.1717054,16.6565893 L12,21 L9.82829464,16.6565893 Z M12,12 C13.1045695,12 14,11.1045695 14,10 C14,8.8954305 13.1045695,8 12,8 C10.8954305,8 10,8.8954305 10,10 C10,11.1045695 10.8954305,12 12,12 Z"
                    fill="#000000"
                  />
                </g>
              </svg>
            </span>
          </template>
        </v-autocomplete>

        <div v-if="neighborhood.length > 0 && cityInfo.all !== true">
          <v-autocomplete
            id="neighborhood"
            v-model="selectedNeighborhood"
            :items="neighborhood"
            clearable
            :loading="loading"
            :no-data-text="$t('LISTS.NoData')"
            :placeholder="
              loading
                ? $t('DIALOGS.Waiting')
                : 'نام محله مورد نظر را جستجو کنید.'
            "
            :readonly="neighborhood.length === 0 || loading"
            :rules="[
              (v) =>
                neighborhood.length === 0 ||
                (v && v !== '') ||
                'فیلد محله را نباید خالی بگذارید!',
            ]"
            :required="force"
            clear-icon="mdi-close-circle-outline"
            dense
            item-text="name"
            item-value="id"
            label="محله"
            name="neighborhood"
            outlined
            :error-messages="errorNeighbor"
            @input="getNeighbor($event)"
          >
            <template v-slot:prepend-inner>
              <span class="svg-icon svg-icon-primary svg-icon-2x">
                <svg
                  height="24px"
                  version="1.1"
                  viewBox="0 0 24 24"
                  width="24px"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g
                    fill="none"
                    fill-rule="evenodd"
                    stroke="none"
                    stroke-width="1"
                  >
                    <rect height="24" width="24" x="0" y="0" />
                    <path
                      d="M9.82829464,16.6565893 C7.02541569,15.7427556 5,13.1079084 5,10 C5,6.13400675 8.13400675,3 12,3 C15.8659932,3 19,6.13400675 19,10 C19,13.1079084 16.9745843,15.7427556 14.1717054,16.6565893 L12,21 L9.82829464,16.6565893 Z M12,12 C13.1045695,12 14,11.1045695 14,10 C14,8.8954305 13.1045695,8 12,8 C10.8954305,8 10,8.8954305 10,10 C10,11.1045695 10.8954305,12 12,12 Z"
                      fill="#000000"
                    />
                  </g>
                </svg>
              </span>
            </template>
          </v-autocomplete>
        </div>
      </v-form>
    </div>
  </div>
</template>

<script>
import { Bus } from "@/main";
import axios from "axios";

export default {
  name: "citySelectorsingle",
  props: {
    force: { type: Boolean, default: false },
    defaultEdit: { type: Boolean, default: false },
    editCity: {
      type: Object,
      default: () => ({ city: [], neighborhood: [], state: [] }),
    },
    MultiCity: { type: Boolean, default: false },
    auto_change: { type: Boolean, default: false },
  },
  data() {
    return {
      city: [],
      states: [],
      neighborhood: [],
      errorCity: "",
      loading: false,
      errorNeighbor: "",
      errorState: "",
      selectedState: "",
      selectedCity: "",
      selectedNeighborhood: "",
      cityInfo: {
        all: false,
        city: [],
        neighborhood: [],
        state: [],
        all_n: false,
      },
    };
  },
  mounted() {
    this.getStates();
    if (this.defaultEdit && this.editCity) {
      this.edition();
    }
  },
  methods: {
    edition() {
      if (this.defaultEdit && this.editCity) {
        this.selectedState = this.editCity.state?.[0]?.toString() || "";
        this.cityInfo.state = this.selectedState ? [this.selectedState] : [];
        this.selectedCity = this.editCity.city?.[0]?.toString() || "";
        this.cityInfo.city = this.selectedCity ? [this.selectedCity] : [];
        this.selectedNeighborhood =
          this.editCity.neighborhood?.[0]?.toString() || "";
        this.cityInfo.neighborhood = this.selectedNeighborhood
          ? [this.selectedNeighborhood]
          : [];
        if (this.selectedCity) {
          this.checkNeighbor(this.selectedCity);
        }
        if (this.selectedState) {
          this.checkCity(this.selectedState);
        }
      }
    },
    requestApiGet(uri, queries = {}, serializer = null) {
      return axios.get(`${this.$robotApi}/${uri}`, {
        headers: this.header(),
        params: queries,
        paramsSerializer: serializer,
      });
    },
    header() {
      return {
        Authorization: Token ? `Bearer ${Token}` : null,
        Accept: "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "*",
        "Access-Control-Allow-Headers": "*",
        "Content-Type": "application/json",
      };
    },
    getStates() {
      this.requestApiGet("divar/cities")
        .then(({ data }) => {
          this.states = data.data || [];
          // console.log("States loaded:", this.states);
        })
        .catch((error) => {
          // console.error("Error fetching states:", error);
          this.states = [];
          // this.errorState = "خطا در بارگذاری استان‌ها";
        });
    },
    checkCity(stateId) {
      if (stateId) {
        // console.log("Fetching cities for state:", stateId);
        this.requestApiGet("divar/cities/parts", { citi_id: [stateId] })
          .then(({ data }) => {
            this.city = data.data
              ? data.data
                  .filter((x) => typeof x.id === "number")
                  .map((x) => ({ ...x, id: x.id.toString() }))
              : [];
            // console.log("Cities loaded:", this.city);
            if (this.city.length === 0) {
              this.errorCity = "هیچ شهری برای این استان یافت نشد";
            }
          })
          .catch((error) => {
            //  console.error("Error fetching city parts:", error);
            this.city = [];
            this.cityInfo.city = [];
            this.selectedCity = "";
            this.neighborhood = [];
            this.cityInfo.neighborhood = [];
            this.selectedNeighborhood = "";
            // this.errorCity = "خطا در بارگذاری شهرها";
          });
      } else {
        this.city = [];
        this.cityInfo.city = [];
        this.selectedCity = "";
        this.neighborhood = [];
        this.cityInfo.neighborhood = [];
        this.selectedNeighborhood = "";
      }
    },
    checkNeighbor(cityId) {
      this.loading = true;
      if (!cityId) {
        this.neighborhood = [];
        this.cityInfo.neighborhood = [];
        this.selectedNeighborhood = "";
        this.loading = false;
        return;
      }
      // console.log("Fetching neighborhoods for city:", cityId);
      axios
        .get(`${this.$robotApi}/divar/districts/${cityId}`, {
          headers: this.header(),
        })
        .then(({ data }) => {
          this.neighborhood = data.data
            ? data.data
                .filter((x) => typeof x.id === "number")
                .map((x) => ({ ...x, id: x.id.toString() }))
            : [];
          // console.log("Neighborhoods loaded:", this.neighborhood);
          this.loading = false;
          if (this.neighborhood.length === 0) {
            this.errorNeighbor = "هیچ محله‌ای برای این شهر یافت نشد";
          }
        })
        .catch((error) => {
          // console.error("Error fetching neighborhoods:", error);
          this.neighborhood = [];
          this.cityInfo.neighborhood = [];
          this.selectedNeighborhood = "";
          this.loading = false;
          // this.errorNeighbor = "خطا در بارگذاری محله‌ها";
        });
    },
    getNeighbor(val) {
      this.selectedNeighborhood = val || "";
      this.cityInfo.neighborhood = val ? [val.toString()] : [];
      // console.log("Selected neighborhood:", this.cityInfo.neighborhood);
    },
    getCity(val) {
      this.selectedCity = val || "";
      this.cityInfo.city = val ? [val.toString()] : [];
      // console.log("Selected city:", this.cityInfo.city);
      if (this.selectedCity) {
        this.checkNeighbor(this.selectedCity);
      } else {
        this.neighborhood = [];
        this.cityInfo.neighborhood = [];
        this.selectedNeighborhood = "";
      }
    },
    getState(val) {
      this.selectedState = val || "";
      this.cityInfo.state = val ? [val.toString()] : [];
      // console.log("Selected state:", this.cityInfo.state);
      this.cityInfo.city = [];
      this.selectedCity = "";
      this.cityInfo.neighborhood = [];
      this.selectedNeighborhood = [];
      this.checkCity(val);
    },
    validate() {
      let validate = true;
      let errors = [];
      if (!this.cityInfo.state.length) {
        this.errorState = "فیلد استان را نباید خالی بگذارید!";
        errors.push(this.errorState);
        validate = false;
      }
      if (!this.cityInfo.city.length) {
        this.errorCity = "فیلد شهر را نباید خالی بگذارید!";
        errors.push(this.errorCity);
        validate = false;
      }
      if (this.neighborhood.length > 0 && !this.cityInfo.neighborhood.length) {
        this.errorNeighbor = "فیلد محله را نباید خالی بگذارید!";
        errors.push(this.errorNeighbor);
        validate = false;
      }
      if (!validate) {
        this.$toast.error(errors.join("\n"), { timeout: 5000 });
      }
      return validate;
    },
  },
  watch: {
    cityInfo: {
      handler(val) {
        const data_for_sending = {
          all: val.all,
          all_n: val.all_n,
          state: val.state || [],
          city: val.city || [],
          neighborhood: val.neighborhood || [],
        };
        // console.log("Emitting cityInfo:", data_for_sending);
        Bus.$emit("cityInfo", data_for_sending);
      },
      deep: true,
    },
  },
};
</script>
<style scoped></style>
